import _Vue from "vue";
import Rollbar from "rollbar";
declare module "vue/types/vue" {
  export interface Vue {
    $rollbar: any;
  }
}

// This exports the plugin object.
export const RollbarPlugin = {
  install(Vue: typeof _Vue, options: any) {
    Vue.prototype.$rollbar = new Rollbar(options);
  }
};
